<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      accordions: [],
    }
  },
  methods: {
    addAccordion(accordion) {
      this.accordions.push(accordion)
    },
    closeAllAccordionsExceptActiveOne(activeAccordion) {
      this.accordions.forEach((acc) => {
        if (acc === activeAccordion) return
        acc.setInvisible()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
